import { render, staticRenderFns } from "./ActivitiesConfigure.vue?vue&type=template&id=72b2be56&scoped=true&"
import script from "./ActivitiesConfigure.vue?vue&type=script&lang=js&"
export * from "./ActivitiesConfigure.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesConfigure.vue?vue&type=style&index=0&id=72b2be56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b2be56",
  null
  
)

export default component.exports